// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".caution-pop[data-v-681f2dbb]{background-color:#aeaeae;height:100%;left:0;position:fixed;top:0;width:100%;z-index:99}.caution-pop img[data-v-681f2dbb]{background-color:#fff;border-radius:15px;bottom:0;left:0;margin:auto;position:fixed;right:0;top:0;width:50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
